import apiHandler from "../core/apiHandler";

/**
 * 🏖️ API para el reporte de turismo por alojamiento (5%)
 * Endpoint: /api/reports/tourism-tax
 */
const tourismTaxReportApi = apiHandler("reports/tourism-tax");

export default tourismTaxReportApi;
